import { trackSuccessAttempt, } from '../../common/buildPayloadsTyped/trackSuccessAttempt.js';
export const trackEmailAttemptSuccessfulRequest = (params) => {
    return trackSuccessAttempt({
        ...params,
        loginMethod: 'standard',
        uniqueName: 'emailPasswordAuthentication',
    });
};
//# sourceMappingURL=trackEmailAttemptSuccessfulRequest.js.map